import { cn } from '@/lib/utils';

interface Props {
  label: string;
  value: string | number;
  className?: string;
}

const StatCard = ({ label, value, className }: Props) => {
  return (
    <div
      className={cn(
        'bg-main-yellow desktop:max-w-[333px] desktop:pt-7 flex min-w-0 flex-1 flex-col items-center justify-center rounded-[15px] px-1.5 pt-5',
        className,
      )}
    >
      {/* pill */}
      <div className="text-level-3 typo-14 desktop:typo-20 desktop:py-[7px] desktop:px-3 min-w-23 rounded-full bg-white py-2 font-bold">
        {label}
      </div>
      {/* 큰 값 */}
      <div className="text-level-2 typo-24 desktop:text-[45px] desktop:pt-4 desktop:leading-[45px] desktop:pb-10 pt-3 pb-5 font-extrabold">
        {value}
      </div>
    </div>
  );
};

export default StatCard;
